<template>
  <div class="passwordChange">
    <form :action="action" method="post" ref="form" @submit.prevent="handleSubmit">
      <input type="hidden" name="_token" :value="csrfToken">
      <h1 class="passwordChange__title">パスワードを再発行する</h1>
      <Attension v-if="!errorPass == 0" :text="errorMsg" class="passwordChange__attension" />
      <p v-else class="passwordChange__body">登録されているメールアドレスを入力してください。パスワード再発行用URLを送信します。</p>
      <form-input     
        v-model="email"
        class="passwordChange__form"
        type="email"
        name="email"
        placeholder="例）uranaitv@uranai.tv"
        label="メールアドレス"
        :validation="{ rules: {
          required: true,
          nonRfcEmailCheck: true,
          email: true
          } }" 
        />
      <ul class="note-list">
        <li class="note-list__item">※info@uranai.tvからパスワード再発行用URLを送信します。メールの設定により、迷惑メールフォルダに振り分けられる場合があります。</li>
        <li class="note-list__item">※キャリアメールをご利用の方でメールが届かない場合は、ドメイン指定を解除してください。</li>
      </ul>
      <BaseButton
        class="passwordChange__button"
        label="送信"
        :isDisabled="errors.items.length > 0 || !email"
        @clicked="handleSubmit"
      />
    </form>
  </div>
</template>

<script>
import BaseButton from './common/BaseButton'
import Attension from './common/Attention'

export default {
  name: 'passwordChange',
  components:{
    BaseButton,
    Attension
  },
  data() {
    return {
      email: ''
    }
  },
  computed:{
    errorMsg(){
      return this.errorPass === 2 ? 'このメールアドレスで登録されたユーザーアカウントがありません。'
            : this.errorPass === 3 ? '対象のパスワード変更メールが有効期限切れか既に変更済みです。変更する際はもう一度再発行をご対応ください'
            : ''
    }
  },
  props: {
    csrfToken: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    errorPass: {
      type: Number,
      default: 0
    },
  },
  methods: {
    handleSubmit() {
      console.log(this.action)
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$refs.form.submit()
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "../../../sass/commons/commonVariables.scss";

.passwordChange{
  padding: 30px 4px 60px;
  color: $col_base_black;

  &__title{
    font-size: 21px;
    line-height: 31px;
    text-align: center;
    margin-bottom: 30px;
  }

  &__attension {
    margin-bottom: 30px;
  }

  &__body{
    white-space: pre-line;
    font-size: 13px;
    line-height: 19px;
    margin: 30px 0;
  }
  &__form {
    padding: 0 10px;
  }
  
  &__button{
    padding: 35px 10px 0;
  }
  .baseButton__button {
    width: 100%;
  }

}
</style>

<style lang="scss" scope>
.note-list {
  padding: 0;
  margin: 0;
  font-size: 11px;
  line-height: 16px;
  &__item {
    list-style: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/PasswordChange.vue